<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd" style="text-align:center">{{signInfo.activity.sa_name}}</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">起始时间</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
              >{{ signInfo.activity.sa_begintime }}</span
            >
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结束时间</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
              >{{ signInfo.activity.sa_endtime }}</span
            >
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">活动地点</label>
            <span class="weui-form-preview__value">{{
              signInfo.activity.sa_address
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">主办单位</label>
            <span class="weui-form-preview__value">{{
              signInfo.activity.sa_organizer
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="signInfo.activity.sa_coorganizer"
          >
            <label class="weui-form-preview__label">协办单位</label>
            <span class="weui-form-preview__value">{{
              signInfo.activity.sa_coorganizer
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="signInfo.activity.sa_guest"
          >
            <label class="weui-form-preview__label">特邀嘉宾</label>
            <span class="weui-form-preview__value">{{
              signInfo.activity.sa_guest
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ signInfo.activity.sa_contact }}
              {{ signInfo.activity.sa_contact_mob }}
              <call-mobile :em-id="signInfo.activity.sa_contact_mob"></call-mobile>
              </span>
          </div>
        </div>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-show="signInfo.activity.sa_desc"
      >
        <div class="weui-panel__hd">活动详情</div>
        <div class="weui-form-preview__bd">
          <div style="white-space:pre-wrap;text-align:left" v-html="signInfo.activity.sa_desc"></div>
        </div>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-show="signInfo.activity.attachList"
      >
        <div class="weui-panel__hd">宣传资料</div>
        <div class="weui-form-preview__bd">
          <file-list :file-list="signInfo.activity.attachList" />
        </div>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-show="signInfo.activity.colAttachList"
      >
        <div class="weui-panel__hd">活动集锦</div>
        <div class="weui-form-preview__bd">
          <file-list :file-list="signInfo.activity.colAttachList" />
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="signInfo.user">
        <div class="weui-panel__hd">报名信息</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">姓名</label>
            <em class="weui-form-preview__value">{{
              signInfo.user.su_username
            }}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">手机号</label>
            <span class="weui-form-preview__value">{{
              signInfo.user.su_mobile
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">公司名称</label>
            <span class="weui-form-preview__value">{{
              signInfo.user.su_corpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="signInfo.user.su_job">
            <label class="weui-form-preview__label">职务</label>
            <span class="weui-form-preview__value">{{
              signInfo.user.su_job
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="signInfo.user.su_applytime">
            <label class="weui-form-preview__label">报名时间</label>
            <span class="weui-form-preview__value">{{
              signInfo.user.su_applytime
            }}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"
              >扫码关注公众号，了解活动更多细节</label
            >
          </div>
          <div class="weixin_qr">
            <img src="../../assets/images/usoft_weixin_qr.png" />
          </div>
        </div>
      </div>
      <div>
        <a
          href="javascript:;"
          class="weui-btn_cell weui-btn_cell-default"
          @click="showList"
          >查看全部记录</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import Finger from "@/util/finger.js";

export default {
  components: {
    FileList,
    CallMobile
  },
  data() {
    return {
      clientId: null,
      signInfo: {
        activity: {},
        user: {}
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var uid = to.params.uid || to.query.uid,
        clientId = to.params.clientId || to.query.clientId;
      if (uid) {
        if (!clientId) {
          clientId = Finger.get();
        }
        vm.clientId = clientId;
        vm.loadData(uid, clientId);
      }
    });
  },
  methods: {
    loadData(uid, clientId) {
      var me = this;
      me.$loading({
        url: "/api/open/crm/activity/sign_info",
        params: {
          uid,
          clientId,
        },
      }).then(function (res) {
        var data = res.data;
        if (data) {
          me.signInfo = data;
        }
      });
    },
    showList() {
      var me = this;
      me.$router.push({
        name: "OpenActivitySignList",
        params: {
          clientId: me.clientId,
        },
        query: {
          clientId: me.clientId,
        },
      });
    },
  },
};
</script>
<style scoped>
.weixin_qr img {
  width: 160px;
  height: 160px;
  display: block;
}
</style>